import { defineStore } from 'pinia';
import carrierData from '../data/carrierServices.json';

// Pre-process data to handle potential issues
const processedCarrierData = carrierData.map(carrier => {
  // Ensure logoPath is properly set
  if (!carrier.logoPath || carrier.logoPath === 'null' || carrier.logoPath === 'undefined') {
    carrier.logoPath = ''; // Set to empty string if null, undefined, or those as strings
  }
  
  // Log issues with carrier data to console for debugging
  if (process.env.NODE_ENV === 'development') {
    if (!carrier.logoPath || carrier.logoPath.trim() === '') {
      console.log(`Carrier ${carrier.name} has empty logoPath`);
    }
  }
  
  return carrier;
});

export const useCarrierDirectoryStore = defineStore('carrierDirectory', {
  state: () => ({
    carriers: [],
    isLoading: false,
    error: null,
  }),
  
  getters: {
    /**
     * Filter carriers based on search term
     * @param {string} searchTerm - The search term to filter carriers by
     * @returns {Array} Filtered list of carriers
     */
    getFilteredCarriers: (state) => (searchTerm) => {
      if (!searchTerm || searchTerm.trim() === '') {
        return state.carriers;
      }
      
      const normalized = searchTerm.toLowerCase().trim();
      
      return state.carriers.filter(carrier => {
        return carrier.name?.toLowerCase().includes(normalized);
      });
    },
    
    /**
     * Get a formatted phone display string
     * @param {Object} carrier - The carrier object  
     * @param {string} type - The type of phone (claims or billing)
     * @returns {string} Formatted phone number or 'Not Available'
     */
    getFormattedPhoneDisplay: () => (carrier, type) => {
      const phone = type === 'claims' ? carrier.claimsPhone : carrier.billingPhone;
      return phone || 'Not Available';
    },
    
    /**
     * Get a formatted phone link for dialing
     * @param {Object} carrier - The carrier object  
     * @param {string} type - The type of phone (claims or billing)
     * @returns {string} Phone link or null
     */
    getFormattedPhoneLink: () => (carrier, type) => {
      const phone = type === 'claims' ? carrier.claimsPhone : carrier.billingPhone;
      if (!phone) return null;
      
      // Remove non-numeric characters for the link
      const digits = phone.replace(/\D/g, '');
      return `tel:${digits}`;
    }
  },
  
  actions: {
    /**
     * Load carriers from local JSON data
     */
    fetchCarriers() {
      this.isLoading = true;
      this.error = null;
      
      try {
        // Use the pre-processed carrier data
        this.carriers = processedCarrierData;
        console.log('Carriers loaded:', this.carriers.length);
      } catch (error) {
        console.error('Error loading carriers:', error);
        this.error = 'Failed to load carrier information. Please try again later.';
      } finally {
        this.isLoading = false;
      }
    },
  }
}); 